<!-- <mat-card-title>{{ 'DEFAULT_ERROR_CODES.' + this.errorHint | underScore | uppercase | translate}}</mat-card-title> -->
<mat-card-title>{{ (translationStatus$ | async) ? (routeParams$ | async | error:true) : ''}}</mat-card-title>

<div
  class="container"
  fxLayout="row"
  fxLayout.xs="column"
  fxLayoutWrap
  fxLayoutGap="0.5%"
  fxLayoutAlign="center"
>
  <div fxFlex="20%">
    <img
      mat-card-image
      src="assets/img/sad-face.svg"
      alt="Image of a sad face"
    />
  </div>
</div>

<!-- <mat-card-content>
    <p>
        {{errorHint | translate}}
    </p>
</mat-card-content> -->

<ng-container *ngIf="requestId">
  <mat-card-actions>
    <app-button
      (clickEvent)="commonFunc.getRedirectedByRequestId()"
      [btnOption]="buttonOptions.backToLogin"
    >
    </app-button>
  </mat-card-actions>
</ng-container>
